import React from 'react';

export default function TermsPage() {
  return (
    <div className="content-page-container">
      <div className="content-page-card">
        <h1>Terms and Conditions</h1>
        <p className="last-updated">Last updated: December 1, 2025</p>

        <section>
          <h2>1. Agreement to Terms</h2>
          <p>
            By accessing or using TollyHype, you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, you may not access the service.
          </p>
        </section>

        <section>
          <h2>2. User Accounts</h2>
          <p>
            To participate in voting and chat, you must create an account. You are responsible for maintaining the confidentiality of your account and password. You agree to accept responsibility for all activities that occur under your account.
          </p>
        </section>

        <section>
          <h2>3. Voting Rules</h2>
          <p>
            Our platform relies on fair play. By using our service, you agree to:
          </p>
          <ul>
            <li>Only vote using your own personal account.</li>
            <li>Not create multiple accounts to manipulate voting results.</li>
            <li>Not use automated scripts or bots to vote.</li>
          </ul>
          <p>
            We reserve the right to disqualify votes or ban users who violate these rules.
          </p>
        </section>

        <section>
          <h2>4. User Conduct</h2>
          <p>
            When using our chat features or interacting with the community, you agree not to:
          </p>
          <ul>
            <li>Harass, abuse, or threaten other users.</li>
            <li>Post content that is hate speech, sexually explicit, or promotes illegal acts.</li>
            <li>Spam or flood the chat.</li>
          </ul>
        </section>

        <section>
          <h2>5. Intellectual Property</h2>
          <p>
            The service and its original content, features, and functionality are and will remain the exclusive property of TollyHype. Movie posters and titles are used for informational purposes only and remain the property of their respective owners.
          </p>
        </section>

        <section>
          <h2>6. Termination</h2>
          <p>
            We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
          </p>
        </section>

        <section>
          <h2>7. Limitation of Liability</h2>
          <p>
            In no event shall TollyHype, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.
          </p>
        </section>

        <section>
          <h2>8. Changes to Terms</h2>
          <p>
            We reserve the right, at our sole discretion, to modify or replace these Terms at any time. What constitutes a material change will be determined at our sole discretion.
          </p>
        </section>

        <section>
          <h2>9. Contact Us</h2>
          <p>
            If you have any questions about these Terms, please contact us at: <a href="mailto:support@tollyhype.com">support@tollyhype.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}

